export default {
  zh: {
   
  },
  en: {
    userManage:'User Manage',
    banorReset:'Ban & Reset',
    banText:"Ban",
    ResetText:"Reset",
    dataText:"Data",
    unBanText:"unBan",
    unbanConf:"Confirm to unban?",
    yes: "confirm",
    no: "cancel",
    successful:"The operation was successful",
    nohad:'No ban permission',
  },
  ar: {
    userManage:'إدارة المستخدم',
    banorReset:'الحظر وإعادة الضبط',
    dataText:"بيانات",
    successful:"العملية كانت ناجحه",
    unBanText:"unBan",
    unbanConf:"Confirm to unban?",
    yes: "أكد",
    no: "إلغاء",
    nohad:'لا يوجد إذن حظر',
    banText:"الحظر",
    ResetText:"اعاده تعيين",
  },
  tr: {
    userManage:'Kullanıcı Yönetimi',
    banorReset:'Yasaklama ve Sıfırlama',
    dataText:"Veri",
    unBanText:"unBan",
    unbanConf:"Confirm to unban?",
    yes: "onaylamak",
    no: "iptal etmek",
    successful:"İşlem Başarılı Oldu",
    nohad:'Yasak izni yok',
    banText:"Yasaklamak",
    ResetText:"Sıfırlama",
  },
  pt:{
    userManage: 'Gerenciar Usuário',
    banorReset: 'Banir & Redefinir',
    banText: "Banir",
    ResetText: "Redefinir",
    dataText: "Dados",
    unBanText: "Desbanir",
    unbanConf: "Confirmar para desbanir?",
    yes: "confirmar",
    no: "cancelar",
    successful: "A operação foi bem-sucedida",
    nohad: 'Sem permissão para banir',

  },
  id:{
    userManage: 'Manajemen Pengguna',
    banorReset: 'Blokir & Atur Ulang',
    banText: "Blokir",
    ResetText: "Atur Ulang",
    dataText: "Data",
    unBanText: "Buka Blokir",
    unbanConf: "Konfirmasi untuk membuka blokir?",
    yes: "konfirmasi",
    no: "batal",
    successful: "Operasi berhasil",
    nohad: 'Tidak memiliki izin blokir',

  },
  uz:{
    "userManage": "Foydalanuvchi boshqaruvi",
    "banorReset": "Ta'qiqlash va tiklash",
    "banText": "Ta'qiqlash",
    "ResetText": "Tiklash",
    "dataText": "Ma'lumot",
    "unBanText": "Ta'qiqni olib tashlash",
    "unbanConf": "Ta'qiqni olib tashlashni tasdiqlaysizmi?",
    "yes": "tasdiqlash",
    "no": "bekor qilish",
    "successful": "Amal muvaffaqiyatli bajarildi",
    "nohad": "Ta'qiqlash huquqi yo'q"
    },
  ru:{
    "userManage": "Управление пользователями",
    "banorReset": "Заблокировать и сбросить",
    "banText": "Заблокировать",
    "ResetText": "Сбросить",
    "dataText": "Данные",
    "unBanText": "Разблокировать",
    "unbanConf": "Подтвердите разблокировку?",
    "yes": "подтвердить",
    "no": "отменить",
    "successful": "Операция выполнена успешно",
    "nohad": "Нет прав на блокировку"
    },
  fa:{
    "userManage": "مدیریت کاربران",
    "banorReset": "مسدود کردن و بازنشانی",
    "banText": "مسدود کردن",
    "ResetText": "بازنشانی",
    "dataText": "داده‌ها",
    "unBanText": "رفع مسدودی",
    "unbanConf": "آیا از رفع مسدودیت اطمینان دارید؟",
    "yes": "تایید",
    "no": "لغو",
    "successful": "عملیات با موفقیت انجام شد",
    "nohad": "مجوز مسدودسازی وجود ندارد"
}


}



// WEBPACK FOOTER //
// src/pages/admin-control/admin-control-user/lang.js